export const isNullOrUndef = (x) => {
    return (x ?? '-0') === '-0';
};
